export default __webpack_public_path__ + "static/rocket-5898468914fe8e328eb6ef1967260638.webp";